'use strict';

var IS_LOADED_CLASS_NAME = 'isLoaded';

// TODO This needs to be finished and support multiple images per element and multple per observer. I bet we can find a good opensource library instead of making our own though.
/* TODO Watch out for native lazy loading (https://web.dev/native-lazy-loading/). This is on automatically for all images in Chrome on Android when lite mode is on. If an image is hidden off screen, for example, it may never load.
		To solve this I am creating a new Image() and watching for "load" event on that instead. This will cause loading to happen even when "native lazy load" is enabled. .. which may not be the best idea since it overrides the user's (and maybe html developer's) intent, but solves the issue for now.
*/

/**
 * @class
 * @classdesc 
 */
function ImageLoadObserver(elem, onLoad) {
	this._elem = elem;
	this._onLoad = onLoad;
	this._onImgLoaded = this._onImgLoaded.bind(this);
	this._inMemoryImg = null;
	
	if (!this.isLoaded()) {
		var img = this._elem.tagName.toUpperCase() === 'IMG' ? this._elem : this._elem.querySelector('img');
		if (img !== null) {
			this._img = img;
			if (img.complete) {
				this._onImgLoaded();
			} else {
				this._inMemoryImg = new Image();
				this._inMemoryImg.addEventListener('load', this._onImgLoaded, false);
				this._inMemoryImg.src = this.getSrc();
			}
		}
	}
}

/**
 * @private
 */
ImageLoadObserver.prototype._onImgLoaded = function() {
	if (this._inMemoryImg !== null) {
		this._inMemoryImg = null;
	}
	if (this._onLoad !== undefined) {
		this._onLoad(this);
	}
	this._isLoaded = true;
	this._elem.classList.add(IS_LOADED_CLASS_NAME);
	
	delete this._onLoad;
}

/**
 * @public
 */
ImageLoadObserver.prototype.getElement = function() {
	return this._elem;
}

/**
 * @public
 * @return {string} - Returns a string. If no image found returns an empty string.
 */
ImageLoadObserver.prototype.getSrc = function() {
	if (this._img === undefined) {
		return '';
	}
	if ('currentSrc' in this._img && this._img.currentSrc.length !== 0) {
		return this._img.currentSrc;
	}
	return  this._img.src;
		// TODO Test this and try using the picturefill polyfill.
}


/**
 * @public
 */
ImageLoadObserver.prototype.isLoaded = function() {
	return this._isLoaded === true;
}

module.exports = ImageLoadObserver; 